import { z } from "zod";

/**
 * ItemFolhaPagamentoVerbaSchema
 */

export const ItemFolhaPagamentoVerbaSchema = z.object({
  idItensVerbaFuncionario: z.array(z.number()).default([]),
});

/**
 * ItemFolhaPagamentoVerbaForm
 */

export type ItemFolhaPagamentoVerbaForm = z.infer<typeof ItemFolhaPagamentoVerbaSchema>;